import React from "react";
import "../../resources/css/application.css";
import iconWarning from "../../resources/images/icon-warning.svg";
import * as PropTypes from "prop-types";


const WarningAlert = (props) => {

  const {message} = props;

  return (
    <div>
      <div className="alert-warning mb-5">
        <img alt={""} className="alert-warning__icon" src={iconWarning}/>
        <p className="alert-warning__msg">{message}</p>
      </div>
    </div>
  );
};

WarningAlert.propTypes = {
  message: PropTypes.string
};

export default WarningAlert;
